import React from "react";
import { Route, Routes } from "react-router-dom";
import { StoreReports, ProductSalesWastageReport } from "./containers";

export const StoreReportsRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<StoreReports />} />
    </Routes>
  );
};

export const ProductSalesWastageReportRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<ProductSalesWastageReport />} />
    </Routes>
  );
};
